var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPeopleManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6006 23.1429C17.3098 21.9712 16.6473 20.9224 15.7093 20.1556C14.7091 19.338 13.457 18.8915 12.1652 18.8915C10.8734 18.8915 9.62133 19.338 8.62113 20.1556C7.68306 20.9224 7.02066 21.9712 6.7299 23.1429",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1646 18.8916C14.2949 18.8916 15.4932 17.6933 15.4932 15.563C15.4932 13.4327 14.2949 12.2344 12.1646 12.2344C10.0342 12.2344 8.83594 13.4327 8.83594 15.563C8.83594 17.6933 10.0342 18.8916 12.1646 18.8916Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 7.51441C19.8375 7.51441 21.0358 6.31611 21.0358 4.18576C21.0358 2.05544 19.8375 0.857117 17.7072 0.857117C15.5768 0.857117 14.3785 2.05544 14.3785 4.18576C14.3785 6.31611 15.5768 7.51441 17.7072 7.51441Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1427 11.7656C22.8519 10.5938 22.1895 9.54507 21.2515 8.77832C20.2514 7.96081 18.9992 7.51422 17.7074 7.51422C16.4156 7.51422 15.1636 7.96081 14.1634 8.77832",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29286 7.51441C4.16252 7.51441 2.96422 6.31611 2.96422 4.18576C2.96422 2.05544 4.16252 0.857117 6.29286 0.857117C8.42319 0.857117 9.62151 2.05544 9.62151 4.18576C9.62151 6.31611 8.42319 7.51441 6.29286 7.51441Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.857277 11.7656C1.14802 10.5938 1.81044 9.54507 2.74851 8.77832C3.74871 7.96081 5.00077 7.51422 6.29257 7.51422C7.58436 7.51422 8.83644 7.96081 9.83664 8.77832",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPeopleManagement);
export default __webpack_public_path__ + "static/media/sidebar_people_management.27b7a34a23a55f2063e6d3b86c37c651.svg";
export { ForwardRef as ReactComponent };